var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","background-color":"#99001e"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/image/building.png"),"alt":""}})])
}]

export { render, staticRenderFns }